import { theme } from "../theme/theme";
export function withSpecificty(trueObj = {}) {
    return {
        ["&&"]: trueObj,
    };
}
export function withForcedSpecificty(trueObj = {}) {
    return withSpecificty(trueObj);
}
export function onCondition(booleanValue, trueObj = {}) {
    if (booleanValue)
        return trueObj;
    else
        return {};
}
export function getFullPageHeight(offset = "0px") {
    return `calc(${theme.heights.appHeight} - ${offset}) !important`;
}
export function getHeightExcludingHeader(offset = "0px") {
    return `calc(${theme.heights.appHeight} - ${theme.heights.headerHeight}px - ${offset})!important`;
}
export function getMobileHeightExcludingHeader(offset = "0px") {
    return `calc(${theme.heights.mobileAppHeight} - ${theme.heights.headerHeight}px - ${offset})!important`;
}
export function getRelativeHeightExcludingHeader(offset = "0px") {
    return `calc(100% - ${theme.heights.headerHeight}px - ${offset})!important`;
}
export function getSvgColorCss(color) {
    return {
        ["path"]: {
            fill: color,
        },
        ["rect"]: {
            fill: color,
        },
        ["polygon"]: {
            fill: color,
        },
        ["circle"]: {
            fill: color,
        },
    };
}
export function getSvgStrokeColorCss(color) {
    return {
        ["path"]: {
            stroke: color,
        },
        ["rect"]: {
            stroke: color,
        },
        ["polygon"]: {
            stroke: color,
        },
        ["circle"]: {
            stroke: color,
        },
    };
}
export function getSvgStrokeColorWithoutFillCss(color) {
    return {
        ["path"]: {
            stroke: color,
            fill: "transparent!important",
        },
        ["rect"]: {
            stroke: color,
            fill: "transparent!important",
        },
        ["polygon"]: {
            stroke: color,
            fill: "transparent!important",
        },
        ["circle"]: {
            stroke: color,
            fill: "transparent!important",
        },
    };
}
/**
 *
 * Breakpoints specific code follows
 *
 */
export const breakPointMap = new Map([
    ["sm", 568],
    ["md", 768],
    ["lg", 1024],
    ["xl", 1280],
    ["xxl", 1920],
]);
const mq = (bp) => `@media (min-width: ${bp}px)`;
export function onMq(breakpoint = "sm", cssObj = {}) {
    return {
        [mq(breakPointMap.get(breakpoint))]: cssObj,
    };
}
export function onMqInPx(breakpoint, cssObj = {}) {
    return {
        [`@media (min-width: ${breakpoint}px)`]: cssObj,
    };
}
export function getLineClamp(lineNumber = 2) {
    return {
        display: "-webkit-box",
        WebkitLineClamp: lineNumber,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
    };
}
export function getLineClampFromVariable(name) {
    return {
        display: "-webkit-box",
        WebkitLineClamp: `var(${name})`,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
    };
}
export function getCssValueForVariablesWithFallback(variables = [], fallback) {
    if (variables.length === 0)
        return fallback;
    let finalValue = fallback;
    variables.forEach((variable) => {
        finalValue = getCssValueForSingleVariableWithFallback(variable, finalValue);
    });
    return finalValue;
}
function getCssValueForSingleVariableWithFallback(variable, fallback) {
    if (!variable)
        return fallback;
    return `var(${variable}, ${fallback})`;
}
//# sourceMappingURL=css-utils.js.map